import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionCta } from '../components/SectionCta';
import { volumes } from '../data/content';
export function Volumes() {
  return <section className="w-full bg-white py-14 sm:py-20" aria-labelledby="volumes-heading" data-id="element-326" data-mp="vmvfumnhaga2">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-327" data-mp="10loh9gphqgtv">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600" data-id="element-328" data-mp="10k54w16ygpxd">
          What’s inside
        </p>
        <h2 id="volumes-heading" className="mx-auto mt-3 max-w-2xl text-center font-display text-[26px] font-black leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-329" data-mp="qniiv92w7str">
          Meet the 6-volume clinical library
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-ink-700 sm:text-lg" data-id="element-330" data-mp="gy8n9j8ubs0w">
          A complete visual system that accompanies you through the major stages of clear
          aligner treatment planning.
        </p>

        <div className="mt-10 space-y-4 sm:space-y-5" data-id="element-331" data-mp="1akb2bk44qds1">
          {volumes.map(volume => <article key={volume.number} className="rounded-2xl border border-navy-900/10 bg-white p-5 shadow-card sm:p-7" data-id="element-332" data-mp="15lq7y1bk6obi">
              <div className="flex flex-col gap-5 sm:flex-row sm:gap-7" data-id="element-333" data-mp="1jj52tlkkzoav">
                <div className="sm:w-[54%]" data-id="element-334" data-mp="1enfzd75fxn9a">
                  <span className="inline-flex rounded-md bg-navy-900 px-2.5 py-1 text-[10.5px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-335" data-mp="qwk23ui7tzun">
                    {volume.number}
                  </span>
                  <h3 className="mt-3 font-display text-[21px] font-extrabold leading-tight tracking-tight text-navy-900 sm:text-[26px]" data-id="element-336" data-mp="10m3ld19ubvq1">
                    {volume.title}
                  </h3>
                  <p className="mt-3 text-[14.5px] leading-relaxed text-ink-700" data-id="element-337" data-mp="85svh0pm4njy">
                    {volume.intro}
                  </p>
                  {volume.note ? <p className="mt-2.5 text-[14.5px] leading-relaxed text-ink-700" data-id="element-338" data-mp="34wscpd355fl">
                      {volume.note}
                    </p> : null}
                </div>

                <div className="rounded-xl bg-brand-50 p-4 sm:w-[46%] sm:p-5" data-id="element-339" data-mp="2868yf7y0w3ud">
                  <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-brand-700" data-id="element-340" data-mp="2czk8rj21n2r1">
                    {volume.insideLabel}
                  </p>
                  <ul className="mt-3 space-y-2" data-id="element-341" data-mp="1kaweixzbh31c">
                    {volume.inside.map(item => <li key={item} className="flex items-start gap-2" data-id="element-342" data-mp="1p8o7zwfm0x7n">
                        <CheckIcon aria-hidden="true" className="mt-[3px] h-4 w-4 shrink-0 text-brand-600" data-id="element-343" data-mp="1u8kd5z01muos" />
                        <span className="text-[13.5px] font-medium leading-snug text-navy-900" data-id="element-344" data-mp="1y7t651n9eoja">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </article>)}
        </div>

        <SectionCta label="Get all 6 volumes for $27" data-id="element-345" data-mp="u0magswq3uyj" />
      </div>
    </section>;
}